/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  SearchDoorsQueryResponse,
  SearchDoorsQueryParams,
} from '../types/SearchDoors'

function getSearchDoorsUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/common/search/doors_name_domain_and_address/` as const,
  }
  return res
}

/**
 * @description Handle GET request for search.
 * This is the main entry point that orchestrates the search process.
 * @summary Search FirstBite doors by name, domain or address
 * {@link /api/v1/common/search/doors_name_domain_and_address/}
 */
export async function searchDoors(
  params: SearchDoorsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    SearchDoorsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getSearchDoorsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
